module.exports = __webpack_public_path__ + "static/media/lesson-finish.37b8de43.png";